//@ts-nocheck

import AdSenseWidget from "../AdSenseWidget";
import AdvancedSearch from "../AdvancedSearchWidget/AdvancedSearch";
import AdvertisementListWidget from "../AdvertisementListWidget/AdvertisementListWidget";
import NewsletterListWidget from "../NewsletterListWidget/NewsletterListWidget";
import InformationListWidget from "../InformationListWidget/InformationListWidget";
import BannerWidget from "../BannerWidget/Banner";
import BlogCarousel from "../BlogCarouselWidget/BlogCarousel";
import BoardsManager from "../BoardsManager";
import ButtonWidget from "../ButtonWidget/ButtonWidget";
import CardReport from "../CardReportWidget/CardReport";
import { getConnectionData } from "../../../util/Scripts";
import FilterWidget from "../FilterWidget";
import FormComplete from "../../FormsV2/FormComplete";
import FormBuilder from "../FormBuilder/FormBuilder";
import FormSettingsModal from "../WidgetsSettings/FormV3/FormSettingsModal";
import FormV3 from "../FormsV3/FormV3Widget";
import IconsWidget from "../IconsWidget/IconsWidget";
import InfiniteList from "../InfiniteListWidget/InfiniteList";
import InfoLineImageWidget from "../InfoLineImageWidget/InfoLineImageWeb";
import Kanban from "../DefaultWidgets/KanbanWidget/KanbanWidget";
import LevelStatus from "../LevelStatusWidget/LevelStatus";
import LinkWidget from "../LinkWidget/LinkWidget";
import { ListWidget } from "../ListWidget/ListWidgetWithSpinner";
import MobileWidget from "../MobileWidget";
import PercentageSummary from "../PercentageSummary/PercentageSummary";
import NewsletterWidget from "../../Newsletter/NewsletterWidget";
import NoteWidget from "../NoteWidget/NoteWidget";
import PictureWebWidget from "../PictureWebWidget/PictureWeb";
import ProductListWidget from "../ProductListWidget/ProductListWidget";
import ProjectSummaryWidget from "../ProjectSummary/ProjectSummaryWidget";
import Ranking from "../RankingWidget/Ranking";
import RoadMap from "../RoadMapWidget/RoadMap";
import SectionWidget from "../SectionWidget/SectionWidget";
import SettingsModal from "../../Modal/SettingsModal";
import ShoppingBasketCardsWidget from "../DefaultWidgets/ShoppingBasketCardsWidget";
import SummaryHopps from "../SummaryWidget/SummaryHopps";
import SummaryWidget from "../SummaryWidget/Summary";
import TimeLineWidget from "../TimelineWidget/TimeLineWidget";
import TranslationWidget from "../../Widgets/TranslationsWidget/Translations";
import Widget from "../../Widget/Widget";
import CalendarWidget from "../CalendarWidget/Calendar";
import LineChartWidget from "../chartsWidgets/LineChart";
import PhotoWidget from "../PhotoWidget/PhotoWidget";
import CircleChart from "../chartsWidgets/CircleChart";
import NewsletterGraph from "../chartsWidgets/NewsletterGraph";
import TableWidget from "../TableWidget/TableWidget";
import MyBoards from "../myBoardsWidget/MyBoardsWidget";
import StripeWidget from "../StripeWidget/StripeWidget";
import { ListSummariesWidget } from "../ListSummariesWidget/ListSummariesWidget";
import { BenefitsChartWidget } from "../BenefitsChartWidget/BenefitsChartWidget";
import ListBuilderWidget from "../ListBuilder/ListBuilderWidget";
import QuestionnaireWidget from "../QuestionnaireWidget/QuestionnaireWidget";

export const renderWidget = (widgetData, role, board, settings, setWidgetHeights) => {
   switch (widgetData.name) {
      case "listSummaries":
         return <ListSummariesWidget value={widgetData} data={board} role={role} />;
      case "pieChart":
         return <BenefitsChartWidget value={widgetData} data={board} role={role} />;
      case "adSense":
         return <AdSenseWidget settings={widgetData} role={role} />;
      case "advancedSearch":
         return <AdvancedSearch value={widgetData} role={role} />;
      case "advertisementList":
         return <AdvertisementListWidget value={widgetData} role={role} data={board} />;
      case "newsletterList":
         return <NewsletterListWidget value={widgetData} role={role} data={board} />;
      case "informationList":
         return <InformationListWidget value={widgetData} role={role} data={board} />;
      case "bannerWeb":
         return <BannerWidget value={widgetData} role={role} />;
      case "blogCarousel":
         return <BlogCarousel value={widgetData} role={role} data={board} />;
      case "boardsManager":
         return <BoardsManager settings={widgetData} role={role} />;
      case "button":
         try {
            if (window?.location) {
               const urlParams = new URLSearchParams(window.location.search);
               const actionValues = JSON.parse(decodeURIComponent(urlParams.get("actionValues")));
               if (actionValues?.[widgetData?.id]) {
                  // In the scenario of process connection, in actionBy we store ID of the process we need to open
                  const actionBy = urlParams.get("actionBy");
                  const actionType = urlParams.get("actionType");
                  const dataIdFromUrl = actionValues[widgetData?.id][actionBy];

                  if (actionType === "process") {
                     widgetData.configId = actionBy;
                     widgetData.dataId = Number(dataIdFromUrl)?.toFixed(0);
                     widgetData.chosenOperation = "configId";
                  }
               }
            }

            return <ButtonWidget value={widgetData} role={role} data={board} />;
         } catch (err) {
            return null;
         }
      case "questionnaire":
         return <QuestionnaireWidget value={widgetData} role={role} />;
      case "calendar":
         return <CalendarWidget settings={widgetData} role={role} />;
      case "cardReport":
         return <CardReport value={widgetData} role={role} />;
      case "chartCircle":
         return <CircleChart value={widgetData} role={role} />;
      case "connectionData":
         if (window?.location) {
            const connectionData = getConnectionData(widgetData.id);
            if (connectionData) {
               widgetData.dataId = Number(connectionData)?.toFixed(0);
            }
         }
         return (
            <Widget
               bgColor={widgetData.backgroundColourHex}
               extra={
                  (role === "OWNER" || role === "MODERATOR") && (
                     <SettingsModal
                        widgetName={widgetData.name}
                        widgetId={widgetData.id}
                        icon="setting"
                        deleteIcon="true"
                        children={<FormSettingsModal value={widgetData} />}
                     />
                  )
               }
            >
               <FormComplete
                  formId={widgetData?.formId}
                  dataId={widgetData?.dataId}
                  printable={widgetData?.printable}
               />
            </Widget>
         );
      case "filter":
         return <FilterWidget value={widgetData} role={role} />;
      case "formBuilder":
         return <FormBuilder value={widgetData} role={role} formId={undefined} data={board} />;
      case "formV2":
         try {
            if (window?.location) {
               const connectionData = getConnectionData(widgetData.id);
               if (connectionData) {
                  widgetData.dataId = Number(connectionData)?.toFixed(0);
               }
            }
            return (
               <Widget
                  bgColor={widgetData.backgroundColourHex}
                  extra={
                     (role === "OWNER" || role === "MODERATOR") && (
                        <SettingsModal
                           widgetName={widgetData.name}
                           widgetId={widgetData.id}
                           icon="setting"
                           deleteIcon="true"
                           children={<FormSettingsModal value={widgetData} />}
                        />
                     )
                  }
               >
                  <FormComplete
                     formId={widgetData?.formId}
                     dataId={widgetData?.dataId}
                     printable={widgetData?.printable}
                     hideAttachments={true}
                  />
               </Widget>
            );
         } catch (err) {
            break;
         }
      case "formV3":
         return <FormV3 role={role} value={widgetData} />;
      case "iconWeb":
         return <IconsWidget value={widgetData} role={role} />;
      case "infoLineImageWeb":
         return <InfoLineImageWidget value={widgetData} role={role} />;
      case "infiniteList":
         return <InfiniteList value={widgetData} role={role} />;
      case "kanban":
         return <Kanban value={widgetData} role={role} />;
      case "levelStatus":
         return <LevelStatus value={widgetData} role={role} />;
      case "lineGraph":
         return <LineChartWidget value={widgetData} role={role} />;
      case "linkWeb":
         return <LinkWidget value={widgetData} role={role} />;
      case "list":
         return <ListWidget value={widgetData} role={role} />;
      case "table":
         return <TableWidget value={widgetData} role={role} />;
      case "mobile":
         return <MobileWidget value={widgetData} role={role} />;
      case "newsletter":
         return <NewsletterWidget value={widgetData} role={role} />;
      case "newsletterGraph":
         return <NewsletterGraph value={widgetData} role={role} />;
      case "percentageSummary":
         return <PercentageSummary value={widgetData} role={role} />;
      case "note":
         return <NoteWidget value={widgetData} role={role} data={board} />;
      case "photoWidget":
         return <PhotoWidget value={widgetData} role={role} />;
      case "pictureWeb":
         return <PictureWebWidget value={widgetData} role={role} />;
      case "productItem":
         return <ProductListWidget value={widgetData} role={role} data={board} />;
      case "projectSummary":
         return <ProjectSummaryWidget value={widgetData} role={role} />;
      case "ranking":
         return <Ranking value={widgetData} role={role} data={board} />;
      case "roadMap":
         return <RoadMap value={widgetData} role={role} />;
      case "sectionJava":
         return <SectionWidget value={widgetData} role={role} />;
      case "shoppingBasketCards":
         return <ShoppingBasketCardsWidget value={widgetData} role={role} />;
      case "summary":
         return <SummaryWidget value={widgetData} role={role} />;
      case "summaryHopps":
         return <SummaryHopps value={widgetData} role={role} />;
      case "timeline":
         return <TimeLineWidget value={widgetData} role={role} />;
      case "translation":
         return <TranslationWidget value={widgetData} role={role} />;
      case "myBoards":
         return <MyBoards value={widgetData} role={role} />;
      case "customCode":
         return <StripeWidget value={widgetData} role={role} />;
      case "listsBuilder":
         return <ListBuilderWidget value={widgetData} role={role} />;
      default:
         return null;
   }
};

interface WidgetHeight {
   widgetId: string;
   widgetHeight: number;
   setWidgetHeights: any;
}

/**
 * Global function to update widget height. We need to import function in specyfic widget to claim data for changing height of widget.
 * @param widgetRef - The reference to the widget DOM element. By this reference we claim widget height in pixes and divide it by scaling func.
 * @param widgetId - The unique ID of the widget. We create list of widgets (interface WidgetHeight structure). Then we compare height with rendered widgets by id.
 * @param setWidgetHeights - Function to update the widgetHeights state in the component. This setState is passed through renderWidgetFunction.
 */
export const getWidgetHeight = (
   widgetRef: HTMLElement | null,
   widgetId: string,
   setWidgetHeights: React.Dispatch<React.SetStateAction<WidgetHeight[]>>,
) => {
   const newMaxHeight = widgetRef?.clientHeight;

   if (widgetRef && widgetId && newMaxHeight) {
      setWidgetHeights((prevWidgetHeights) => {
         const safeWidgetHeights = Array.isArray(prevWidgetHeights) ? prevWidgetHeights : [];
         const existingWidget = safeWidgetHeights.find((widget) => widget.widgetId === widgetId);

         if (existingWidget) {
            if (existingWidget.widgetHeight !== newMaxHeight) {
               return safeWidgetHeights.map((widget) =>
                  widget.widgetId === widgetId ? { ...widget, widgetHeight: newMaxHeight } : widget,
               );
            } else {
               return safeWidgetHeights;
            }
         } else {
            return [...safeWidgetHeights, { widgetId, widgetHeight: newMaxHeight }];
         }
      });
   }
};

/**
 * Calculates the value of h based on the target height.
 *
 * The function uses the formula:
 *
 *   h = (targetHeight - baseHeight) / additionalHeight + 1
 *
 * Where:
 * - baseHeight is a constant representing the minimum height (10).
 * - additionalHeight is a constant representing the height added for each additional row (20).
 *
 * @param {number} targetHeight - The target height for which to calculate h.
 * @returns {number} The calculated value of h based on the given target height.
 *
 * @example
 * // returns 20
 * const result = calculateHForHeight(390);
 *
 * @example
 * // returns 1
 * const result = calculateHForHeight(10);
 */
export const calculateHForWidget = (targetHeight) => {
   const baseHeight = 10;
   const additionalHeight = 20;

   const h = (targetHeight - baseHeight) / additionalHeight + 1;

   return h;
};
